import { Environment } from './model';

export const environment: Environment = {
  WEB_URL: 'https://frosty-shtern.185-93-166-119.plesk.page',
  API_URL: 'https://api.frosty-shtern.185-93-166-119.plesk.page/api',  
  GRAPHQL_URL: 'https://api.frosty-shtern.185-93-166-119.plesk.page/graphql',
  PRODUCTION: false,
};
